module.exports = __webpack_public_path__ + "static/media/propic6.2605ee84.psd";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/about/propic6.psd
// module id = 45
// module chunks = 0